export const BILLING_TYPES = [
  { value: "self-pay", label: "Self Pay" },
  { value: "insurance", label: "Insurance" },
];
